import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpInterceptor,
    HttpHandler,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { UtilService } from '../services/util.service';

@Injectable()
export class AuditHeaderInterceptor implements HttpInterceptor {
    //public auditNotes: string = "";

    constructor(private utilService: UtilService) { }

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const employeeID = localStorage.getItem('EmployeeId') || '-2';
        const modifiedRequest = request.clone({
            setHeaders: {
                "X-Employee-ID": employeeID,
                "X-Audit-Notes": this.utilService.getAuditNotes(),
            }
        })
        return next.handle(modifiedRequest);
    }
}
